module.exports = __webpack_public_path__ + "static/img/school-10.720e947.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-10.png
// module id = JNV3
// module chunks = 0